import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faLinkedin, faYoutube } from '@fortawesome/free-brands-svg-icons';
import logoWhite from '../../../images/Logo/MrSea2025_logo_white.png';
import '../../styles/Footer.css';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <div className="footer-company-info">
            <div className="footer-logo">
              <a href="/">
                <img src={logoWhite} alt="Logo" className="footer-logo" />
              </a>
            </div>
            
            <p className="footer-description">Miami’s premier boat rental and yacht charter company, delivering unforgettable experiences on the water.</p>
            <div className="footer-social-icons">
              <a href="https://www.instagram.com/mrseamiami/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.linkedin.com/company/mr-sea-boat-rentals-miami/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://www.youtube.com/@mr.seamiami3153" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="mailto:hello@mrseamiami.com" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div>
        </div>
        <div className="footer-column">
          <div className="footer-links">
            <h3>Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/faqs-page">FAQs</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <p>
            <a target="_blank" rel="noopener noreferrer" href="https://altovalleit.com/?utm_source=mrseamiami&utm_medium=referral&utm_campaign=portfolio">Developed by AltoValleIT</a>
          </p>
        </div>
        <div className="footer-bottom-links">
          <a href="/terms">Terms of Service</a>
          <span style={{ color: '#888', margin: '0 0.7em' }}>|</span>
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
